module.exports = __webpack_public_path__ + "img/strategy1.ad57b030.jpg";